import * as React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

export function NavItems() {
  return (
    <nav>
      <ul>
        {/* Each nav item is inside an li element */}
        {/* Instagram */}
        <li>
          <a
            href="https://www.instagram.com/lumberob/"
            className="non-standard"
            target="_blank"
            rel="noopener noreferrer"
            aria-label='instagram'
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </li>
        {/* Contact */}
        <li id="first">
         
          <a
            target="_blank"
            rel="noreferrer nofollow"
            href="https://shimmy-disc.net/shimmy-2010.html"
          >
            new release
          </a>
        </li>
        <li id="second">
          {/* <a
            target="_blank"
            rel="noreferrer nofollow"
            href="https://youtu.be/7Vk2DEeDOVA"
          >
            new videos
          </a> */}
          <Link to="/new-videos">New Videos</Link>
         
        </li>
       
        {/* Old Video */}
        <li id="third">
          <Link to="/video-archive">video archive</Link>
        </li>
        <li id="fourth">
          <Link to="/contact">contact</Link>
        </li>
      </ul>
    </nav>
  )
}

export default NavItems
